import { Box, Typography } from '@packages/shared';
import { Html } from '../Html';
import { LinkByButton } from '../LinkByButton';
import { LinkByText } from '../LinkByText';
import type { LinkBoxItemContentComponentType } from './types';
import type { ButtonType, Layout } from '../../../interfaces';

const mapButtonTypeToFieldLayout = (buttonType: ButtonType): Layout => {
  switch (buttonType) {
    case 'button-primary':
      return 'primary';
    case 'button-secondary':
      return 'secondary';
    default:
      return 'base';
  }
};

/**
 * The LinkBoxItemContent component displays content of the LinkBox
 */
export const LinkBoxItemContent = ({
  data: {
    // content
    field_subline_90: subline,
    field_headline_120: headline,
    field_html_editor: htmlContent,
    // call to action
    field_button_text: buttonText,
    behavior_paragraph_cta_icon: buttonIcon = false,
    behavior_paragraph_cta_size: buttonSize = 'small',
    behavior_paragraph_cta_type: buttonType = 'button-default',
  },
  link,
  isLandscape,
}: LinkBoxItemContentComponentType) => (
  // component="span" prevents warning ==> validateDOMNesting(...): <a> cannot appear as a descendant of <a>
  <Box
    sx={{
      width: isLandscape ? '50%' : '100%',
      height: '100%',
      p: 1.5,
    }}
  >
    {subline && <Typography>{subline}</Typography>}
    {headline && (
      <Typography sx={{ mb: 1 }} typography="h4" fontWeight="600">
        {headline}
      </Typography>
    )}
    {htmlContent && (
      <Box
        sx={{
          mb: 1,
        }}
      >
        <Html data={{ type: 'html', field_html_editor: htmlContent }} />
      </Box>
    )}
    {link !== '' && buttonText && buttonType !== 'textlink' && buttonType && (
      <LinkByButton
        data={{
          type: 'link_by_button',
          field_link: link,
          field_text: buttonText,
          field_layout: mapButtonTypeToFieldLayout(buttonType),
          behavior_paragraph_size: buttonSize,
        }}
        icon={buttonIcon ? 'ArrowRight' : undefined}
      />
    )}
    {link !== '' && buttonText && buttonType === 'textlink' && (
      <LinkByText
        data={{
          type: 'link_by_text',
          field_link: link,
          field_text: buttonText,
          field_icon: buttonIcon ? 'ArrowRight' : undefined,
        }}
      />
    )}
  </Box>
);
